<template>
  <div>
    <vs-card class="mt-5">
      <ACard>
        <template v-if="skeleton">
          <a-skeleton />
        </template>
        <template v-else>
          <template v-if="current_account">
            <template slot="title">
              {{ 'Account name : ' + (current_account && current_account.account_name ? current_account.account_name : '-') }}
            </template>
            <template slot="extra">
              <div class="flex gap-2">
                <a-button v-if="hasPermission('bank-account.withdrawal')" type="primary" ghost @click="addAccountTransaction('WithDraw')" style="border-radius: 3px !important;">WithDraw</a-button>
                <a-button v-if="hasPermission('bank-account.deposit')" type="primary" @click="addAccountTransaction('Deposit')" style="border-radius: 3px !important;">Deposit</a-button>
                <a-button v-if="hasPermission('bank-account.transfer-balance')" type="primary" ghost @click="addTransferFunds" style="border-radius: 3px !important;">Transfer Funds</a-button>
              </div>
            </template>
            <a-descriptions>
              <a-descriptions-item label="Balance">
                {{ $refs.history.data && $refs.history.data.length ? $refs.history.data[0].balance.toFixed(2) : '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="Account type">
                {{ current_account.account_type === 2 ? 'Client Account' : 'Operating Account' }}
              </a-descriptions-item>
              <a-descriptions-item label="Account number">
                {{ current_account.account_number || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="Swift">
                {{ current_account.swift || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="Account holder">
                {{ current_account.account_holder || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="Institution">
                {{ current_account.institution || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="Domicile branch">
                {{ current_account.domicile_branch || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="Sort code">
                {{ current_account.sort_code || '-' }}
              </a-descriptions-item>
            </a-descriptions>
          </template>
        </template>
      </ACard>
    </vs-card>

    <vs-card class="p-5 mt-5">
      <XTable
        :model="model_history"
        ref="history"
        :options="{ placeholder:'Search transaction',noContent: 'No transactions',is_row_selection: false,is_load_req: false,temp_row: null }"
      >
        <span slot="date" slot-scope="text,record">
          {{ setDateFormat(text.record.created_at) }}
        </span>
        <span slot="fund_out" slot-scope="text,record">
          <template v-if="text.record.amount < 0">
            {{ text.record.amount.toFixed(2) }}
          </template>
        </span>
        <span slot="fund_in" slot-scope="text,record">
          <template v-if="text.record.amount > 0">
            {{ text.record.amount.toFixed(2) }}
          </template>
        </span>
        <span slot="client" slot-scope="text,record">
          <template v-if="text.record.client">
              <template v-if="text.record.client.person">
                {{ text.record.client.person.first_name + ' ' + text.record.client.person.last_name }}
              </template>
              <template v-if="text.record.client.company">
                {{ text.record.client.company.name }}
              </template>
            </template>
        </span>
        <span slot="running_balance" slot-scope="text,record">
          {{ text.record.balance.toFixed(2) }}
        </span>
      </XTable>
    </vs-card>

    <a-modal centered :visible="openAccountTransaction" :width="700" :title="type_transfer" @cancel="cancelTransAction">
        <a-form :form="form" @submit.prevent="handleTransaction">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <a-form-item label="Amount" has-feedback>
              <a-input
                v-decorator="['amount',{ rules: [{ required: true, message: 'This field is required.' }] }]"
                autocomplete="none"
                @keypress="onlyNumber"
                placeholder="0.00"
              />
            </a-form-item>
            <a-form-item label="Date" has-feedback>
              <a-date-picker
                v-decorator="['created_at',{ rules: [{ required: true, message: 'This field is required.' }] }]"
                placeholder="dd/mm/yyyy"
                class="w-full"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
          </div>
          <a-form-item label="Account" has-feedback>
            <a-select
              allowClear
              class="select"
              v-decorator="['bank_account_id',{ initialValue:current_account ? current_account.id : undefined,rules: [{ required: true, message: 'This field is required.' }] }]"
              show-search
              :filterOption="filterOption"
            >
              <a-select-option v-for="item in accounts" :value="item.id">
                {{ item.account_name }} ({{ item.balance !== null ? `RM${item.balance}` : 'No Balance' }})
              </a-select-option>
            </a-select>
          </a-form-item>
          <selectSearch
            :required="false"
            url="/contact/query/"
            :options="{placeholder: 'Choose a client',label: 'Client',field: 'client',width: '100%', allow_clear: true}"
            class="w-full"
            @selectSearch="handleSearchContact"
            placeholder="Search to contact"
          />
<!--          @selectSearchValue="selectSearchValue"-->
          <selectSearch
            ref="matters"
            :required="false"
            url="/matter/query/"
            :options="{placeholder: 'Choose a matter',label: 'Matter',field: 'matter',width: '100%', allow_clear: true}"
            class="w-full"
            :is_include_matter="true"
            @selectSearch="handleSearch"
            placeholder="Search to matter"
          />
<!--          <a-form-item label="Source/Recipient" has-feedback>-->
<!--            <a-input-->
<!--              v-decorator="['source_recipient',{ initialValue: undefined }]"-->
<!--              autocomplete="none"-->
<!--            />-->
<!--          </a-form-item>-->
<!--          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">-->
<!--            <a-form-item label="Currency" has-feedback>-->
<!--              <a-select-->
<!--                allowClear-->
<!--                class="select"-->
<!--                v-decorator="['currency',{ initialValue: current_account.currency ? current_account.currency.id : undefined ,rules: [{ required: true, message: 'This field is required.' }] }]"-->
<!--                show-search-->
<!--                :filterOption="filterOption"-->
<!--              >-->
<!--                <a-select-option v-for="item in currency" :value="item.id">-->
<!--                  {{ item.name }} ({{ item.symbol}})-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--            <a-form-item label="Exchange rate" has-feedback>-->
<!--              <a-input-->
<!--                v-decorator="['exchange_rate',{initialValue: 1}]"-->
<!--                autocomplete="none"-->
<!--              />-->
<!--            </a-form-item>-->
<!--            <a-form-item label="Type" has-feedback>-->
<!--              <a-input-->
<!--                v-decorator="['transaction_type',{ initialValue: undefined }]"-->
<!--                autocomplete="none"-->
<!--              />-->
<!--            </a-form-item>-->
<!--          </div>-->
          <a-form-item label="Cheque or reference no." has-feedback>
            <a-input
              v-decorator="['ref_id',{ initialValue: undefined }]"
              autocomplete="none"
            />
          </a-form-item>
          <a-form-item label="Description" has-feedback>
            <a-textarea v-decorator="['description', {rules: [{required: true}] }]" />
          </a-form-item>
          <a-divider/>
          <div class="flex space-x-2">
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
              Record transaction
            </a-button>
            <a-button type="primary" ghost @click="openAccountTransaction = false" style="border-radius: 3px !important;">
              Cancel
            </a-button>
          </div>
        </a-form>
    </a-modal>

    <a-modal centered :visible="openTransferFunds" :width="700" title="Transfer funds" @cancel="cancelTransferFund">
      <a-form :form="formTransferFund" @submit.prevent="handleTransferSubmit">
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <div class="grid grid-cols-2">
            <a-form-item>
              <a-radio-group v-model="typeTransferFund" name="radioGroup" @change="radioTransferFund">
                <a-radio :style="radioStyle" :value="1">
                  Between bank accounts
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Between matters
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <a-form-item label="Date" has-feedback>
            <a-date-picker
              v-decorator="['created_at',{ initialValue:new Date().toISOString() ,rules: [{ required: true, message: 'This field is required.' }] }]"
              placeholder="dd/mm/yyyy"
              :format="dateFormat"
              class="w-full"
            />
          </a-form-item>
        </div>

        <selectSearch
          :required="true"
          url="/contact/query/"
          @selectSearchValue="(value) => selectSearchTransferFund(value ,2)"
          @selectSearch="handleChangeContact"
          :options="{placeholder: 'Choose a contact',label: 'Contact',field: 'contact',width: '100%', allow_clear: true}"
          class=" w-full"
        />

        <div v-show="formTransferFund.getFieldValue('contact')">
          <selectSearch
            v-if="typeTransferFund === 1"
            :required="false"
            ref="matters"
            url="/matter/query/"
            :is_include_matter="true"
            @selectSearchValue="(value) => selectSearchTransferFund(value ,3)"
            @selectSearch="handleChangeMatter"
            :options="{placeholder: 'Choose a matter',label: 'Matter',field: 'matter',width: '100%', allow_clear: true}"
            class="w-full"
          />

          <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4" >
            <a-form-item label="Source">
              <a-select
                allowClear
                class="select"
                @change="handleChangeSourceBankAccount"
                v-decorator="['from_bank_account',{ rules: [{ required: true, message: 'This field is required.' }] }]"
              >
                <a-select-option v-for="account in sourceOptions" :value="account.id">
                  <template v-if="account.owner">
                    <template v-if="account.owner.hasOwnProperty('title')">
                      {{ account.bank_account.account_name }} - {{ account.owner.title }} - {{ 'RM' + account.balance }}
                    </template>
                    <template v-else>
                      <template v-if="account.owner.person">
                        <feather-icon icon="UserIcon" svg-classes="w-4 h-4 text-primary" style="vertical-align: middle"></feather-icon>
                       {{ account.bank_account.account_name }} - {{ account.owner.person.first_name }} {{ account.owner.person.last_name }} - {{ 'RM' + account.balance }}
                      </template>
                      <template v-else>
                        <feather-icon icon="BriefcaseIcon" svg-classes="w-4 h-4 text-primary" style="vertical-align: middle"></feather-icon>
                        {{ account.bank_account.account_name }} - {{ account.owner.company.name }} - {{ 'RM' + account.balance }}
                      </template>
                    </template>
                  </template>
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Destination">
              <a-select
                allowClear
                class="select"
                v-decorator="['to_bank_account',{ rules: [{ required: true, message: 'This field is required.' }] }]"
              >
                <a-select-option
                  v-for="destination in destinationOptions"
                  :disabled="destination.source_id === formTransferFund.getFieldValue('from_bank_account')"
                  :value="destination.id"
                >
                  {{ typeTransferFund === 1 ? destination.account_name : destination.title  }} - {{ hasAmountAccount(destination) }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <a-form-item label="Amount" has-feedback>
            <a-input
              v-decorator="['amount',{ whiteSpace:true,rules: [
              { required: true, message: 'This field is required.' },
              { validator: (rule,value) => value <= parseFloat(sourceSelectValue.balance), message: 'The transfer amount must be smaller than the account balance.'  }
            ]}]"
              autocomplete="off"
              @keyup="onlyNumber"
            />
          </a-form-item>

          <a-form-item label="Description" has-feedback>
            <a-textarea
              v-decorator="['description',{ whiteSpace:true,rules: [{ required: false }] }]"
              autocomplete="off"
              rows="5"
            />
          </a-form-item>

          <a-divider/>

          <div class="flex items-baseline space-x-2">
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
              Save fund
            </a-button>
            <a-button type="primary" ghost @click="cancelTransferFund" style="border-radius: 3px !important;">
              Cancel
            </a-button>
          </div>
        </div>

      </a-form>
    </a-modal>

    <deleteItem
      :url="`/bank-account/transaction/${temp_row}/`"
      subject="Account transaction"
      :ele="$refs.transaction"
      ref="deleteItemAccountTransaction"
    />

  </div>

</template>

<script>
import XTable from '../../components/x-table/XTable'
import * as TableHistory from './historyTbl'
import axios from '@/axios'
import deleteItem from '../communications/deleteItem'
import mixin from '../mixin/mixin'
import selectSearch from "@/views/forms/selectSearch";
import SelectOption from "../forms/SelectOptionSingle"
import moment from 'moment'
import XTbl,{Xtc} from '../../components/x-table/index';

export default {
  name: "AccountTransaction",
  mixins:[mixin],
  components:{
    XTable,
    deleteItem,
    selectSearch,
    SelectOption
  },
  data(){
    return{
      typeTransferFund        : 1,
      model_history           : null,
      type_transfer           : null,
      current_account         : null,
      sourceSelectValue       : null,
      temp_row                : undefined,
      row                     : undefined,
      contact_value           : undefined,
      accounts                : [],
      sourceOptions           : [],
      destinationOptions      : [],
      matters                 : [],
      skeleton                : false,
      openTransferFunds       : false,
      openAccountTransaction  : false,
      formTransferFund        : this.$form.createForm(this, {name: 'coordinated'}),
    }
  },
  methods:{

    addTransferFunds(){
      this.openTransferFunds = true
    },

    handleSearchContact(value){
      this.contact_value = value
      this.handleChangeContact(value)
    },

    cancelTransAction(){
      this.openAccountTransaction = false
    },

    cancelTransferFund(){
      this.openTransferFunds = false
    },

    radioTransferFund(e) {
      this.typeTransferFund = e.target.value
      this.formTransferFund.resetFields(['contact','to_bank_account','from_bank_account'])
    },

    addAccountTransaction(transfer){
      this.type_transfer = transfer
      this.openAccountTransaction = true
    },

    hasAmountAccount(item) {
      if (item.amount !== undefined) return 'RM' + item.amount
      else if (this.formTransferFund.getFieldValue('matter')) return '(Matter balance)'
      else if (this.formTransferFund.getFieldValue('contact')) return '(Client balance)'
    },

    async handleChangeMatter(value) {
      try{
        this.formTransferFund.resetFields('from_bank_account')
        this.destinationOptions = []
        this.sourceOptions      = []
        if (value === undefined || value === ''){
          await this.selectSearchTransferFund(this.formTransferFund.getFieldValue('contact'),2)
        }
      }catch (e) {
        throw new Error(e)
      }
    },

    handleTransferSubmit(){
      this.formTransferFund.validateFields(async (err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            const { sourceSelectValue } = this
            const data = {
              s_type        : sourceSelectValue.type,
              s_bank_account: sourceSelectValue.bank_account.id,
              s_owner_id    : sourceSelectValue.owner_id,
              d_type        : sourceSelectValue.type,
              d_owner_id    : this.typeTransferFund === 1 ? sourceSelectValue.owner_id : values.to_bank_account,
              d_bank_account: this.typeTransferFund === 1 ? values.to_bank_account : sourceSelectValue.bank_account.id,
              amount        : parseFloat(values.amount),
              description   : values.description,
              created_at    : values.created_at
            }
            await axios.post('/bank-account/transfer-balance/',data)
            await this.getAccountTranActions()
            this.openTransferFunds = false
            this.formTransferFund.resetFields()
            this.$notification['success']({
              message: 'Success',
              description: `Money transfer was done.`,
            });
            await this.getAccounts()
          }catch (e){
            this.$notification['error']({
              message: 'Error',
              description: `Server Error.`,
            });
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },

    handleTransaction(){
      this.form.validateFields(async (err, values) => {
        if(!err){
          try {
            this.$vs.loading()
            for (const [key, value] of Object.entries(values)) {
              if(value === '') values[key] = undefined
            }
            if (values.bank_account_id && !(values.matter && values.client)) {
              values.owner_id = values.bank_account_id
              values.type = 1
            }
            if (values.bank_account_id && values.client && !values.matter) {
              values.owner_id = values.client
              values.type = 2
            }
            if (values.bank_account_id && (values.client || !values.client) && values.matter) {
              values.owner_id = values.matter
              values.type = 3
            }
            values.matter = undefined
            values.client = undefined
            values.amount = parseFloat(values.amount)
            const url = this.type_transfer === 'Deposit' ? '/bank-account/deposit/' : '/bank-account/withdrawal/'
            await axios.post(url,values)
            await this.getAccountTranActions()
            this.form.resetFields()
            this.$notification['success']({
              message: 'Success',
              description: `Account transaction created`,
            });
            this.openAccountTransaction = false
            await this.getAccounts()
          }catch (e) {
             if (e.status === 422) {
               this.$notification['error']({
                 message: 'Error',
                 description: e.data,
               });
             }
              if (e.status === 500) {
                this.$notification['error']({
                  message: 'Error',
                  description: 'Server Error',
                });
              }
              this.openAccountTransaction = true
          } finally {
              this.$vs.loading.close()
          }
        }
      })
    },

    async handleChangeContact(value) {
      try {
        if (value) {
          this.$refs.matters.matters = []
          this.formTransferFund.resetFields('matter')
          this.form.resetFields('matter')
          const {data} = await axios.post('matter/query/',{ limit: 9999 ,query:[{ field:'client__id',condition:'=',value: value }]})
          this.$refs.matters.matters = data.rows
        }
      }catch (e) {
        throw new Error(e)
      }
    },

    async getAccounts(){
      try{
        const {data} = await axios.post('/bank-account/query/',{ limit: 100 })
        this.accounts = data.rows
      }catch (e) {
        this.$message.error('Error receiving currency.')
        throw new Error(e)
      }
    },

    async getOneAccounts(){
      try{
        this.skeleton = true
        const {data} = await axios.get(`/bank-account/${this.$route.params.id}/`)
        this.current_account = data
      }catch (e) {
        this.$message.error('Error receiving currency.')
      }
      finally {
        this.skeleton = false
      }
    },

    async getAccountTranActions(){
      let listOfRow;
      let length;
      try{
        this.$refs.history.loading = true
        const { data } = await axios.get(`/bank-account/transactions/${this.$route.params.id}/`)
        length = data.rows.length
        listOfRow = data.rows
      }catch (e) {
        this.$message.error('Error receiving information')
      }finally {
        this.$refs.history.loading = false
      }
      this.$refs.history.data = listOfRow
    },

    async selectSearchValue(value){
      try {
        const {data} = await axios.post('matter/query/',{ limit: 9999 ,query:[{ field:'client__id',condition:'=',value: value }]})
        // this.$refs.matters.matters = data.rows
        this.destinationOptions = data.rows
      } catch (e) {
        this.$message.error('Server Error')
        throw new Error(e)
      }
    },

    async getMatters(value){
      try {
        const {data} = await axios.post('matter/query/',{ limit: 9999 ,query:[{ field:'client__id',condition:'=',value: value }]})
        this.destinationOptions = data.rows
      } catch (e) {
        this.$message.error('Server Error')
        throw new Error(e)
      }
    },

    async selectSearchTransferFund(value,type) {
      try {
        this.formTransferFund.resetFields(['to_bank_account','from_bank_account'])
        this.sourceOptions = []
        this.destinationOptions = []
        if (this.typeTransferFund === 1) {
          const {data} = await axios.post(type === 3 ? `/bank-account/get-matter-balance/${value}/` : `/bank-account/get-client-balance/${value}/`)
          this.sourceOptions = data.rows
        }else {
          const {data} = await axios.post(`/bank-account/get-client-matter-balance/`,{ bank_account: this.current_account.id, client_id: value })
          this.sourceOptions = data.rows
        }
      }catch (e) {
        this.$message.error('Server Error')
        throw new Error(e)
      }
    },

    dateCreated(date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },

    async handleChangeSourceBankAccount(id) {
      const arr = []
      const accountOrMatter = (this.typeTransferFund === 1 ? this.accounts : this.matters)
      const findAccounts = this.sourceOptions.find(item => item.id === id)
      if (findAccounts !== undefined) this.sourceSelectValue = findAccounts
      for (let i of accountOrMatter) {
        for (let j of this.sourceOptions) {
          if (this.typeTransferFund === 1 && i.id === j.bank_account.id) {
            i['amount'] = j.balance.toFixed(2)
            i['source_id'] = j.id
          }
          if (this.typeTransferFund === 2 && i.id === j.owner_id) {
            i['amount'] = j.balance.toFixed(2)
            i['source_id'] = j.id
          }
        }
        arr.push(i)
      }
      if (id !== undefined){
        if (this.typeTransferFund === 1)
          this.destinationOptions = arr
        if (this.typeTransferFund === 2)
          await this.getMatters(this.formTransferFund.getFieldValue('contact'))
      } else {
        this.destinationOptions = []
        this.formTransferFund.resetFields('to_bank_account')
      }
    },
  },
  mounted() {
    this.is_click_add_time = true
    this.getAccounts()
    this.getOneAccounts()
    this.getAccountTranActions()
    // this.getMatters()
  },
  created() {
    const tbl = new XTbl(`/bank-account/transactions/${this.$route.params.id}/`)
    tbl.add(new Xtc('created_at', 'Date').renderSlot('date').noSort())
    tbl.add(new Xtc('description', 'Source/Recipient').noSort())
    tbl.add(new Xtc('ref_id', 'Reference Code').noSort())
    tbl.add(new Xtc('id', 'Client').noSort().renderSlot('client'))
    tbl.add(new Xtc('matter.title', 'Matter').noSort())
    tbl.add(new Xtc('to_bank_account', 'Funds in').noSort().renderSlot('fund_in'))
    tbl.add(new Xtc('from_bank_account', 'Funds out').noSort().renderSlot('fund_out'))
    tbl.add(new Xtc('balance', 'Running Balance').noSort().renderSlot('running_balance'))
    this.model_history = tbl
    // this.model_history = TableHistory.default
  }
}
</script>

<style >
@import "../style/style.css";
.ant-modal{
  position: relative;
  top: 40px;
}
.ant-btn.ant-btn-link{
  color: #3A3DBE !important ;
}
</style>
